/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OpportunitySummary } from "./OpportunitySummary";
import {
  OpportunitySummaryFromJSON,
  OpportunitySummaryFromJSONTyped,
  OpportunitySummaryToJSON,
  OpportunitySummaryToJSONTyped,
} from "./OpportunitySummary";

/**
 *
 * @export
 * @interface OpportunitiesResponse
 */
export interface OpportunitiesResponse {
  /**
   *
   * @type {Array<OpportunitySummary>}
   * @memberof OpportunitiesResponse
   */
  opportunities: Array<OpportunitySummary>;
}

/**
 * Check if a given object implements the OpportunitiesResponse interface.
 */
export function instanceOfOpportunitiesResponse(
  value: object,
): value is OpportunitiesResponse {
  if (!("opportunities" in value) || value["opportunities"] === undefined)
    return false;
  return true;
}

export function OpportunitiesResponseFromJSON(
  json: any,
): OpportunitiesResponse {
  return OpportunitiesResponseFromJSONTyped(json, false);
}

export function OpportunitiesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OpportunitiesResponse {
  if (json == null) {
    return json;
  }
  return {
    opportunities: (json["opportunities"] as Array<any>).map(
      OpportunitySummaryFromJSON,
    ),
  };
}

export function OpportunitiesResponseToJSON(json: any): OpportunitiesResponse {
  return OpportunitiesResponseToJSONTyped(json, false);
}

export function OpportunitiesResponseToJSONTyped(
  value?: OpportunitiesResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    opportunities: (value["opportunities"] as Array<any>).map(
      OpportunitySummaryToJSON,
    ),
  };
}
